import useLedgerLive from "./useLedgerLive";
import { useUtm } from "./useUtm";

const useUserType = () => {
  const { isLedgerConnected } = useLedgerLive();
  const utmParams = useUtm();

  const utmSource = utmParams?.utm_source
    ? utmParams.utm_source.split("?")[0]
    : "";

  return {
    isStaderLedgerUser: utmSource === "stader_labs" && isLedgerConnected,
  };
};

export default useUserType;
